
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { forget, sendSms, sendEmail } from '../service/getdata'
import areaList from '../components/areaList.vue'
export default {
components: {
XHeader,
Toast,
areaList
},
data() {
return {
icon: "",
read: false,
dialCode: 1,
type: 2,
username: "",
password: "",
msg: "",
show: false,
input_type: 'password',
password2: '',
input_type2:  'password',
paypwd: "",
input_type3:  'password',
rcode: "", //邀请码
vcode: "", //验证码
isClicked: false,
getpassTime: 120,//计时
submitBtn: this.$t("获取验证码"),//发送按钮提示信息

}
},
created() {
},
computed:{
...mapState(['url'])
},
methods: {
...mapMutations(['SETTOKEN']),
timerun() {
const that = this;
setTimeout(function () {
that.getpassTime--;
if (that.getpassTime < -1) {
that.submitBtn = that.$t("重新发送");
that.getpassTime = 120;
that.isClicked = false;
return;
}

if(that.submitBtn != that.$t("获取验证码")){
that.submitBtn = that.getpassTime + " s";
that.timerun();
}

}, 1000);
},
getPassword(){
if(this.username=='' && this.type==3){
this.sendMsg(this.$t("请输入手机号"))
}else if(this.username=='' && this.type==2){
this.sendMsg(this.$t("请输入邮箱"))
}else{

this.getPwd()
}

},
getPwd(){
var that = this
if(!!that.isClicked){
return
}
this.$Loading()
if(this.type==3){
sendSms({country_code: this.dialCode, user_string: this.username}).then(function(res){
var res = res.data;

that.$Loading.close()
if(res.status=='1'){
that.isClicked = true;
that.submitBtn = that.getpassTime + " s";
that.timerun();
}else{
that.sendMsg(res.message)
}
}.bind(this),function(error){
that.$Loading.close()
that.sendMsg("error")
})
}else{
sendEmail({ user_string: this.username ,scene:'findpass'}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.isClicked = true;
that.submitBtn = that.getpassTime + " s";
that.timerun();
}else{
that.sendMsg(res.message)
}
}.bind(this),function(error){
that.$Loading.close()
that.sendMsg("error")
})
}

},
getName (params) {
this.icon = params.code;
this.dialCode = params.dialCode;
},
onSelectArea ()  {
this.$refs.controlChildRef.open();
},

save() {
const that = this;
if(!this.username || this.username == ''){
this.sendMsg(this.$t('请输入登录账号'))
return
}

if(this.password == ''){
this.sendMsg(this.$t('请输入登录密码'))
return
}

if(this.password2 == ''){
this.sendMsg(this.$t('请再次输入密码'))
return
}

if(this.password != this.password2){
this.sendMsg(this.$t('请确认两次密码输入一致'))
return
}
if(this.type!=1 && this.vcode==''){
this.sendMsg(this.$t('请输入验证码'))
return
}

const params = {
mobile: this.username,
email: this.username,
password: this.password,
password2: this.password,
vcode: this.vcode,
type: this.type == 2 ? 'email' : "mobile"

}
this.$Loading()
forget(params).then(function (res) {
var res = res.data;
that.$Loading.close()
if (res.status=='1') {
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.$router.go("-1")

}
})

} else {
that.sendMsg(res.message)
}
}.bind(this), function (error) {
that.$Loading.close()
that.sendMsg(that.$t('注册失败'))
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
}
},
watch:{
type: {
handler(curVal, oldVal) {
if(curVal!=oldVal){
this.isClicked = false
this.username = ''
this.submitBtn = this.$t("获取验证码")
}


},
deep: true
},

}
}



// WEBPACK FOOTER //
// ./src/pages/forget.vue